import React, { useEffect, useState } from "react";
import blogFetch from "../../axios/config";
import { Checkbox, FormControlLabel } from "@mui/material";
import {
  IGroup,
  IUserGroupsProps,
  IUserGroups,
} from "./UserGroupsInterfaces";

export default function UserGroups({
  user,
  groups,
  setGroups
}: IUserGroupsProps) {
  const [toggleRender, setToggleRender] = useState<boolean>(false);
  const [localGroups, setLocalGroups] = useState<IGroup[]>(groups);

  useEffect(() => {
    const fetchData = async () => {
      let Grupos = await getUserGroups();
      await getUserGroupsById(Grupos);
    };

    fetchData();
  }, []);

  const getUserGroups = async () => {
    try {
      let response = await blogFetch.get(`/group`);
      let data = response.data;
      setLocalGroups(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getUserGroupsById = async (gruposProps: IGroup[]) => {
    try {
      let response = await blogFetch.get(`/UsersGroups/${user.user_Id}`);
      let data: IUserGroups[] = response.data;
      let list: any[] = [];
      for (let i = 0; i < data.length; i++) {
        list.push(data[i].group.group_Id);
      }
      const newCheckList = gruposProps.map((item) => {
        const container = item;
        if (list.includes(item.group_Id)) {
          container["checked"] = true;
        } else {
          container["checked"] = false;
        }

        return container;
      });

      setLocalGroups(newCheckList);
      setToggleRender(!toggleRender);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newCheckList = localGroups;
    for (let i = 0; i < newCheckList.length; i++) {
      if (newCheckList[i].group_Id.toString() === event.target.value) {
        newCheckList[i].checked = event.target.checked;
        break;
      }
    }
    setGroups(newCheckList);
    setLocalGroups(newCheckList);
    setToggleRender(!toggleRender);
  };

  const renderGroups = () => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))",
        gap: 6,
      }}
    >
      {!!localGroups &&
        localGroups.map((group) => {
          const isChecked = !!group.checked;
          return (
            <FormControlLabel
              key={group.group_Id}
              sx={{
                margin: 0,
                padding: "4px 8px",
                borderRadius: "6px",
                border: isChecked
                  ? "1.5px solid #9ed6de"
                  : "1.5px solid #e0e0e0",
                backgroundColor: isChecked ? "#eef8fa" : "#fafafa",
                transition: "all 0.15s",
                "&:hover": {
                  borderColor: "#9ed6de",
                  backgroundColor: isChecked ? "#e0f2f5" : "#f0f0f0",
                },
                "& .MuiFormControlLabel-label": {
                  fontSize: 13,
                  fontWeight: isChecked ? 500 : 400,
                  color: isChecked ? "#2e7d82" : "#555",
                  userSelect: "none",
                },
              }}
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={handleCheck}
                  name={group.group_description}
                  value={group.group_Id.toString()}
                  size="small"
                  sx={{
                    color: "#bbb",
                    "&.Mui-checked": { color: "#5bb5bd" },
                  }}
                />
              }
              label={group.group_description}
            />
          );
        })}
    </div>
  );

  return (
    <div>
      <p
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: "#444",
          marginBottom: 10,
        }}
      >
        Grupos
      </p>
      {toggleRender ? renderGroups() : <section>{renderGroups()}</section>}
    </div>
  );
}
